exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".date-picker-parent-container>.date-picker-container{width:calc(50% - 5px);margin-right:10px}label.date-picker-label{font-weight:700;font-size:12px;display:block}input.date-picker{line-height:34px;padding-left:10px;padding-right:10px;border-radius:4px;border:1px solid #ccc;width:100%}.date-picker-container>div{display:flex}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/DateFilter/DateFilter.less
 ** module id = 1058
 ** module chunks = 0
 **/